export const popupStyles = (theme: any) => ({
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: 'hidden',
    padding: '24px',
    display: 'flex',
    height: '80%',
  },
  imagesContainer: {
    flex: 1,
    paddingLeft: 24,
    paddingBottom: 24,
    overflow: 'auto',
    position: 'relative' as const,
  },
  imageListContainer: {
    flex: '0 0 200px',
    maxWidth: '200px',
    borderRight: 'none',
    overflow: 'auto',
  },
  imageContainer: {
    flex: 1,
    padding: 16,
    overflow: 'auto',
    height: '100%',
  },
  imageContainerIframe: {
    flex: 1,
    padding: 0,
    overflow: 'auto',
    height: '100%',
    position: 'relative' as const,
  },
  imageContainerIframeHidden: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    visibility: 'hidden' as const,
    pointerEvents: 'none' as const,
  },
  contentWrapper: {
    width: '100%',
    height: '100%',
  },
  contentWrapperHidden: {
    display: 'none',
  },

  listSubHeader: {
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    cursor: 'default',
    padding: '0px 8px 8px 8px',
    color: theme.TextColor,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    position: 'relative' as const,
  },
  listItem: {
    fontSize: theme.headerTextFontSize,
    cursor: 'pointer',
    color: theme.ColumnHeaderTextColor,
    textTransform: 'capitalize' as const,
    padding: '8px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 180,
    '&$listItemSelected, &$listItemSelected:hover, &$listItemSelected:focus': {
      backgroundColor: theme.HeaderSelectedText,
      color: theme.palette?.common?.white,
    },
    '&:hover': {
      backgroundColor: theme.AppBGColor,
    },
  },
  listItemSelected: {},
  listContainer: {
    padding: '8px 0',
  },

  imageGridContainer: {
    display: 'flex' as const,
    flexWrap: 'wrap' as const,
    overflowX: 'auto' as const,
    flex: 1,
  },
  imageListNotAvailable: {
    opacity: 0.5,
    flex: 1,
    textAlign: 'center' as const,
  },
  imageListItem: {
    padding: 4,
    width: 220,
    height: 260,
    cursor: 'pointer',
  },
  imageListContainerStart: {
    alignItems: 'flex-start',
  },
  imageListContainerCenter: {
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.iconColor,
  },

  imageMetaDataHeader: {
    position: 'relative' as const,
  },
  imageMetaDataFooter: {
    position: 'absolute' as const,
    bottom: 0,
    left: 0,
    backgroundColor: theme.loadingBGColor,
    borderWidth: '0 4px 4px 4px',
    borderStyle: 'none solid solid solid' as const,
    borderColor: theme.ModalBGColor,
    padding: 5,
    width: 211,
  },
  imageMetaDataEdrFooter: {
    left: 1,
    width: '83%',
    bottom: 1,
    padding: 5,
    position: 'absolute' as const,
    backgroundColor: theme.loadingBGColor,
    borderWidth: '0 4px 4px 4px',
    borderStyle: 'none solid solid solid' as const,
    borderColor: theme.ModalBGColor,
  },
  imageMetaDataRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 3,
  },
  imageMetaDataDate: {
    color: theme.iconColor,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: '10px',
    margin: '3px 12px 3px 1px',
    fontWeight: 400,
  },
  imageMetaDataSeparator: {
    color: theme.iconColor,
    fontSize: 4,
  },

  imageAddressRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 3,
  },
  imageAddressIcon: {
    marginRight: 2,
    fontSize: 16,
    color: theme.dispatchPanelLabelValueColor,
  },
  imageAddressText: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    lineHeight: '16px',
    fontWeight: 500,
  },

  loadingContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingMessage: {
    marginTop: 16,
    color: theme.TextColor,
  },

  errorContainer: {
    alignSelf: 'center',
    flex: 1,
    textAlign: 'center',
    color: theme.gridTextColor,
  },
  errorMessage: {
    color: theme.ErrorMessageColor,
    marginBottom: 16,
  },

  emptyContainer: {
    alignSelf: 'center',
    flex: 1,
    textAlign: 'center',
    color: theme.gridTextColor,
  },

  noData: {
    alignSelf: 'center',
    flex: 1,
    textAlign: 'center',
    color: theme.gridTextColor,
  },
});
